/**
 * Tap tempo for the roll header. Median of the last few inter-tap intervals - the median, not the
 * mean, so one late tap does not drag the tempo the way it would in an average.
 *
 * Returns `null` until there is an interval to measure. The result is clamped into
 * `melodySchema`'s 20-300 bpm range, so a double-tap cannot write an invalid entity.
 */

/** Enough taps to settle, few enough to follow a player who speeds up. */
const WINDOW = 5

export const bpmFromTaps = (timestampsMs: number[]): number | null => {
  if (timestampsMs.length < 2) {
    return null
  }
  const intervals = timestampsMs.slice(1).map((t, i) => t - timestampsMs[i])
  const recent = intervals.slice(-WINDOW).sort((a, b) => a - b)
  const middle = Math.floor(recent.length / 2)
  const median = recent.length % 2 === 1 ? recent[middle] : (recent[middle - 1] + recent[middle]) / 2

  return Math.min(300, Math.max(20, Math.round(60000 / median)))
}
